module.exports = __webpack_public_path__ + "static/media/LandingPageVideoPortrait.4b65158c.jpg";